/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_PUR_SUMMARY_ITEM = {
  id: 'purchases_summary',
  screenId: 'met-pur-summary',
  label: 'Resumen',
  description: 'Totales de compras del período.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Vista general de facturas de compra: importes, cantidad y gráficos del período (fecha contable).',
      },
      {
        title: 'Período',
        bullets: ['Atajos Hoy / Semana / Mes / Mes anterior / Personalizado.', 'Opción de unificar monedas en ARS.'],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_PUR_EVOLUTION_ITEM = {
  id: 'purchases_evolution',
  screenId: 'met-pur-evolution',
  label: 'Evolución',
  description: 'Compras en el tiempo.',
  detail: {
    sections: [
      {
        title: 'Vistas',
        bullets: [
          'Semestral — compras por mes con inflación y ajuste (últimos 6 meses o semestres anteriores).',
          'Mensual — compras por día (últimos 30 días o meses anteriores).',
          'Diaria — compras por hora del día (última semana).',
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_PUR_FILTERS_ITEM = {
  id: 'purchases_filters',
  screenId: 'met-pur-filters',
  label: 'Filtros',
  description: 'Compras por tipo de comprobante o usuario.',
  detail: {
    sections: [{
      title: 'Pestañas',
      bullets: [
        'Tipo de factura — desglose por comprobante.',
        'Usuarios — compras registradas por usuario.',
      ],
    }],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_PUR_PROVIDERS_ITEM = {
  id: 'purchases_providers',
  screenId: 'met-pur-providers',
  label: 'Proveedores',
  description: 'Ranking, categorías y detalle por proveedor.',
  detail: {
    sections: [{
      title: 'Pestañas',
      bullets: [
        'Ranking — proveedores con más compras.',
        'Categorías de proveedores — compras por grupo dentro de una categoría.',
        'Por proveedor — detalle de un proveedor.',
      ],
    }],
  },
}
